import { fetchAuthSession } from 'aws-amplify/auth'

const getBaseUrl = () => process.env.REACT_APP_API_URL

async function authHeaders() {
  const { tokens } = await fetchAuthSession()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokens.idToken.toString()}`,
  }
}

export const api = {
  async getStockRange() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/stock/range`, { headers })
    if (!res.ok) throw new Error('Failed to fetch stock range')
    return res.json()
  },

  async getStockPrices(symbol, { start, end } = {}) {
    const headers = await authHeaders()
    const params = new URLSearchParams()
    if (start) params.append('start', start)
    if (end) params.append('end', end)
    const query = params.toString()
    const url = `${getBaseUrl()}/stock/prices/${symbol}${query ? `?${query}` : ''}`
    const res = await fetch(url, { headers })
    if (!res.ok) throw new Error('Failed to fetch stock prices')
    return res.json()
  },
}
